import type { PropsWithChildren } from 'react';

import classNames from 'classnames';
import { Container } from 'reactstrap';

import styles from './styles.module.scss';

interface MarketingPageSection
  extends PropsWithChildren<{
    className?: string;
    innerClass?: string;
    id?: string;
  }> {}

const MarketingPageSection = ({ children, className, innerClass, id }: MarketingPageSection) => {
  return (
    <section id={id} className={classNames(styles.section, className)}>
      <Container className={classNames(styles.sectionInnerContainer, innerClass)}>{children}</Container>
    </section>
  );
};

export default MarketingPageSection;
